import { AbstractControl, ValidationErrors } from '@angular/forms';
import { Produktdaten } from '../../../../generated/model/produktdaten.model';
import { Adresse } from '../../../../generated/model/adresse.model';
import { ZaehlerType } from '../../../model/zaehler-typ.model';
import { CustomValidators } from '@shared-ikp/utils/validators';
import { ProduktFormValue } from '../schemas';

export function mapProduktdatenToFormValue(produktdaten: Produktdaten[]): ProduktFormValue {
  return {
    produkte: produktdaten.map(produkt => ({
      category: produkt.produkt,
      isSelected: true,
      zaehlpunktnummer: produkt.zaehlpunktnummer,
      zaehlerNr: produkt.zaehlerNr ?? null,
      zaehlerSpecs: {
        zaehlerType: mapZaehlerTypeToForm(produkt),
        zaehlerstand: produkt.zaehlerstand ?? null,
        hasNoZaehlerstand: produkt.hasNoZaehlerstand ?? false,
      },
    })),
  };
}

export function mapFormValueToProduktdaten(
  formValue: ProduktFormValue,
  vertragsnummer: string | undefined,
  adresse: Adresse | undefined,
): Produktdaten[] {
  return formValue.produkte.map(produkt => {
    const isKonventionell = produkt.zaehlerSpecs.zaehlerType === ZaehlerType.KONVENTIONELL;
    const hasZaehlerstand = isKonventionell && !produkt.zaehlerSpecs.hasNoZaehlerstand;

    return {
      vertragsnummer,
      zaehlpunktnummer: produkt.zaehlpunktnummer,
      zaehlerNr: validValueOrNull(produkt.zaehlerNr, CustomValidators.meterNumberValidator),
      produkt: produkt.category,
      isSmartMeter: mapToIsSmartMeterStoreModel(produkt.zaehlerSpecs.zaehlerType),
      zaehlerstand: hasZaehlerstand ? validValueOrNull(produkt.zaehlerSpecs.zaehlerstand, CustomValidators.meterCountValidator) : null,
      hasNoZaehlerstand: isKonventionell ? produkt.zaehlerSpecs.hasNoZaehlerstand : false,
      adresse,
    };
  });
}

function validValueOrNull(value: string | null, validator: (control: AbstractControl) => ValidationErrors | null): string | null {
  if (!value) {
    return null;
  }
  return validator({ value } as AbstractControl) === null ? value : null;
}

function mapZaehlerTypeToForm(produkt: Produktdaten): ZaehlerType | null {
  if (produkt.isSmartMeter === null || produkt.isSmartMeter === undefined) {
    return null;
  }
  return produkt.isSmartMeter ? ZaehlerType.SMART_METER : ZaehlerType.KONVENTIONELL;
}

function mapToIsSmartMeterStoreModel(zaehlerType: ZaehlerType | null): boolean | null {
  if (zaehlerType === null) {
    return null;
  }
  return zaehlerType === ZaehlerType.SMART_METER;
}
